module.exports = __webpack_public_path__ + "img/defaultCoinIco.edc0c0d3.png";